export const SET_PRODUCTS_DATA = "SET_PRODUCTS_DATA";
export const SET_PRODUCT_LIST_LOADING = "SET_PRODUCT_LIST_LOADING"
export const SET_PRODUCT_CATEGORIES_LIST = "SET_PRODUCT_CATEGORIES_LIST"
export const SET_PRODUCT_FILTER =  "SET_PRODUCT_FILTER";
export const SET_PRODUCT_BY_ID =  "SET_PRODUCT_BY_ID";
export const SET_SECTIONS =  "SET_SECTIONS";
export const SET_SECTIONS_BY_ID= "SET_SECTIONS_BY_ID";